/*
 * @Author: httishere
 * @Date: 2021-12-30 11:41:28
 * @LastEditTime: 2024-01-23 10:24:53
 * @LastEditors: Tina Huang
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /notion/widgets/src/router.js
 */
import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import FirstPanel from "./components/home/FirstPanel.vue";

Vue.use(Router);

export default new Router({
  // mode: 'history',
  // base: process.env.NODE_ENV === "production" ? '/notion-widgets-site/' : '/',
  routes: [
    {
      path: "/code",
      name: "code",
      component: () => import("./views/Code.vue"),
    },
    // { path: '*', component: NotFoundComponent },
    {
      path: "/",
      name: "home",
      component: Home,
      redirect: "/index",
      children: [
        {
          path: "/index",
          name: "index",
          component: FirstPanel,
        },
        {
          path: "/releases",
          name: "log",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Log.vue"),
        },

        {
          path: "/reward",
          name: "reward",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/Reward.vue"),
        },
        {
          path: "/create/:id/:type",
          name: "create",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Edit.vue"),
        },
        {
          path: "/news",
          name: "news",
          component: () => import("./views/News.vue"),
        },
        {
          path: "/picks/:tab?",
          name: "picks",
          component: () => import("./views/Templates.vue"),
        },
        {
          path: "/picks/get",
          name: "picks_get",
          component: () => import("./views/TemplateGets.vue"),
        },
        // {
        //   path: "/picks/paid",
        //   name: "paid",
        //   component: () => import("./views/TempDetail.vue"),
        // },
        {
          path: "/picks/paid/:id",
          name: "paid",
          component: () => import("./views/TemplateDetail.vue"),
        },
        {
          path: "/pro",
          name: "pro",
          component: () => import("./views/VIP.vue")
        },
        {
          path: "/sticker",
          name: "sticker",
          component: () => import("./views/Sticker.vue")
        },
        {
          path: "/comments",
          name: "comments",
          component: () => import("./views/MainComments.vue")
        }
      ],
    },
    {
      path: "/lib",
      name: "lib",
      component: () => import("./views/Lib.vue"),
      redirect: "/lib/time",
      children: [
        {
          path: "/lib/time",
          name: "time",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/Times.vue"),
        },
        {
          path: "/lib/eff",
          name: "eff",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/Eff.vue"),
        },
        {
          path: "/lib/others",
          name: "others",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/Others.vue"),
        },
        {
          path: "/lib/formula",
          name: "formula",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/Formula.vue"),
        },
      ],
    },
    // m 站
    {
      path: "/m",
      name: 'mbase',
      redirect: '/mindex',
      component: () => import('./views/mobile/Home.vue'),
      children: [
        {
            path: "/mindex",
            name: "mindex",
            component: () => import('./views/mobile/Index.vue'),
        },
        {
          path: "/mwids",
          name: "mwids",
          component: () => import('./views/mobile/Wids.vue')
        },
        {
          path: "/mcreate/:id/:type",
          name: "mcreate",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/mobile/Create.vue"),
        },
        {
          path: "/mpicks",
          name: "mpicks",
          component: () => import("./views/mobile/Template.vue"),
        },
        {
          path: "/mpicks/get/:type?/:code?",
          name: "mpicks_get",
          component: () => import("./views/TemplateGets.vue"),
        },
        {
          path: "/mpro",
          name: "mpro",
          component: () => import("./views/mobile/VIP.vue")
        },
        {
          path: "/mlink/:id?",
          name: "mlink",
          component: () => import("./views/mobile/CreateLink.vue")
        }
      ]
    }
  ],
});
